// extracted by mini-css-extract-plugin
export default {"container":"IllustrationContainer_container__PN2yP"};